import React from 'react';
import Reveal from './Reveal';

const extras = [
  {
    id: 1,
    title: "Ücretsiz İkramlıklarımız",
    description: "Dairelerimizde konforunuz için özenle hazırlanan sıcak çay, Nescafe ve su ikramlarımızla keyifli molalar verin.",
    image: "https://customer-assets.emergentagent.com/job_business-polish-1/artifacts/pcgxawfd_%C3%87ay.jpeg"
  },
  {
    id: 2,
    title: "Zengin Kahvaltı",
    description: "Güne enerjik başlamanız için hazırlanan, bol çeşitli, taptaze ve lezzetli kahvaltı servisimiz sizleri bekliyor.",
    image: "https://customer-assets.emergentagent.com/job_business-polish-1/artifacts/a5hofam3_Kahvalt%C4%B1.jpeg"
  },
  {
    id: 3,
    title: "Tek Kullanımlık Ürünler",
    description: "Sağlığınız ve hijyeniniz önceliğimiz. Kişiye özel paketlenmiş tek kullanımlık terlik, şampuan ve banyo setlerimiz.",
    image: "https://customer-assets.emergentagent.com/job_business-polish-1/artifacts/hb8jipda_Terlik.jpeg"
  }
];

const Extras = () => {
  return (
    <section id="extras" className="py-24 bg-black border-t border-zinc-900" data-testid="extras-section">
      <div className="container mx-auto px-4 md:px-8">
        <Reveal className="text-center mb-16">
          <h2 className="text-sm font-bold text-yellow-500 tracking-[0.3em] uppercase mb-3">Size Özel</h2>
          <h3 className="font-display text-3xl md:text-4xl font-semibold text-white">Ekstra Hizmetlerimiz</h3>
          <div className="w-24 h-px bg-yellow-500 mx-auto mt-6"></div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {extras.map((item, idx) => (
            <Reveal key={item.id} delay={idx * 0.12} className="h-full">
              <div
                className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden group hover:border-yellow-500/50 transition-all duration-300 hover:shadow-[0_0_40px_-10px_rgba(234,179,8,0.25)] flex flex-col h-full"
                data-testid={`extra-card-${item.id}`}
              >
                <div className="relative overflow-hidden bg-black p-4 flex-1 flex items-center justify-center">
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-all z-10 pointer-events-none"></div>
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-auto max-h-96 object-contain transform group-hover:scale-105 transition-transform duration-700 rounded-xl"
                  />
                </div>
                <div className="p-8 bg-zinc-900 border-t border-zinc-800 shrink-0">
                  <h4 className="font-display text-2xl font-semibold text-white mb-3">{item.title}</h4>
                  <p className="text-zinc-400 text-sm leading-relaxed">{item.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Extras;
